export const AUTH_MIN_HEIGHT = {
	LOGIN: { xs: 0, sm: 460 },
	SIGNUP: { xs: 0, sm: 582 }
};
export const FAST_CHECKOUT_MIN_HEIGHT = { xs: 450, sm: 510 };
export const AUTH_MIN_WIDTH = { xs: 'calc(100vw - 20px)', sm: 'auto' };
